<template>
    <div class="classList">
        <div class="top-search">
            <el-form
                    :model="SearchFormModel"
                    :rules="SearchFormRules"
                    ref="SearchFormRef"
                    size="small"
            >
                <form-com
                        :FormField="SearchFormField"
                        :FormModel="SearchFormModel"
                        :formLabelWidth="SearchFormLabelWidth"
                        :key="timer"
                ></form-com>
                <el-form-item>
                    <el-button
                            type="success"
                            @click="submitForm"
                    >搜索
                    </el-button>
                    <!-- <el-button @click="resetForm('SearchFormRef')">重置</el-button> -->
                </el-form-item>
            </el-form>
        </div>
        <div class="tab-box">
            <!-- <div class="tab-title-btn">
                <div>
                    <el-button
                            type="success"
                            @click="addStudent"
                            size="small"
                    >+ 新增学员
                    </el-button>
                    <el-button
                            type="danger"
                            @click="delStudentBtn"
                            size="small"
                    >删除学员
                    </el-button>
                    <el-button
                            type="primary"
                            @click="registerCourse"
                            size="small"
                    >注册课程
                    </el-button>
                </div>
                <div @click="ImportExcelOpen">EXCEL导入学员</div>
            </div> -->
            <!-- list table -->
            <div class="student-list">
                <el-table
                        ref="multipleTable"
                        :data="tableData"
                        border
                        tooltip-effect="dark"
                        style="width: 100%"
                        class="bg-header td-table"
                        size="small"
                        @selection-change="handleSelectionChange"
                >
                    <!-- <el-table-column
                            fixed="left"
                            type="selection"
                            align="center"
                    >
                    </el-table-column> -->
                    <!-- 列表 -->
                    <el-table-column
                            v-for="(item, index) in tableField"
                            :key="index"
                            :prop="item.prop"
                            :label="item.label"
                            :align="item.align"
                            :width="item.width"
                            show-overflow-tooltip
                    >
                    </el-table-column>
                    <!-- <el-table-column
                            label="操作"
                            align="center"
                            fixed="right"
                            width="200"
                    >
                        <template slot-scope="scope">
                            <el-button @click="handleClick('reset_password', scope.row)" type="text" size="small">重置密码</el-button>
                            <el-button @click="handleClick('setting', scope.row)" type="text" size="small">学员设置</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>

            <div class="page-block">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="this.limit"
                        layout="sizes, prev, pager, next, jumper"
                        :total="totalCount"
                >
                </el-pagination>
            </div>
        </div>
        <!-- 导入学员 -->
        <ImportExcel ref="ImportExcel" :classId="classId"></ImportExcel>
        <!-- 选择课程 -->

    </div>
</template>

<script>
    import {
        StudentList,
        ClassListSelect,
        ResetPasswordStudent,
        UnjoinStudent,
        SaveStudent,
        BatchDelStudent,
        CourseList,
        TextbookList,
        SaveCourse,
        courseCardLog
    } from "@/api/teacher";
    import {
        TeacherSearchStudent_field,
        ResetPasswordStudent_field,
        TeacherAddStudent_field,
        TeacherStudentCourse_field,
        TeacherSearchCourseCard_field
    } from "@/config/FormField";
    import Lockr from "lockr";
    import {getFormData, getSelectData} from "@/utils/form";
    import FormCom from "@/components/Element/FormCom";
    import DialogForm from "@/components/Element/DialogForm/index";
    import ImportExcel from "./components/ImportExcel";

    export default {
        name: "studentList",
        components: {
            FormCom,
            ImportExcel
        },
        data() {
            return {
                // 筛选
                timer: "",
                SearchFormModel: {},
                SearchFormField: TeacherSearchCourseCard_field,
                SearchFormRules: {},
                SearchFormLabelWidth: "",
                // 列表
                tableField: [
                    {
                        prop: "card_account",
                        label: "开课卡号"
                    },
                    {
                        prop: "student_emp_no",
                        label: "学生账号"
                    },
                    {
                        prop: "student_name",
                        label: "学生姓名",
                        align: "center"
                    },
                    {
                        prop: "curriculum_info.name",
                        label: "课程名称",
                        width: "160px"
                    },
                    {
                        prop: "curriculum_info.edition_name",
                        label: "课程版本",
                    },
                    {
                        prop: "create_time",
                        label: "开课时间",
                        align: "center"
                    }
                ],
                page: 1,
                limit: 10,
                tableData: [],
                currentPage: 1,
                totalCount: 0,
                multipleSelection: [],
                // 导入
                classId: this.$route.query.class_id
            };
        },
        methods: {
            async init() {
                let res = getFormData(TeacherSearchStudent_field);
                this.SearchFormModel = res.model;
                this.SearchFormRules = res.rules;
                this.timer = new Date().getTime();
                this.tableList();
            },
            // 重置搜索
            resetForm(formName) {
                this.queryResult = {};
                this.$refs[formName].resetFields();
                this.refreshTable();
            },
            // 搜索
            submitForm(formName) {
                this.classId = this.SearchFormModel.class_id
                this.refreshTable()
            },
            // 开课列表
            async tableList() {
                let {create_time_range, ...params} = this.SearchFormModel;
                    params.token = Lockr.get("teacherToken")
                    params.page = this.page
                    params.limit = this.limit
                    if (create_time_range) {
                        params.create_time_range = create_time_range[0] + ' ~ ' +create_time_range[1]
                    }
                let result = await courseCardLog(params);
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    let list = result.data.dataList;
                    let arr = [];
                    if (list && list.length > 0) {
                        arr = list.map(item => {
                            item.is_valid_text =
                                item.is_valid == 1 ? "启用" : "禁用";
                            item.sex_text = item.sex == 1 ? "男" : "女";
                            return item;
                        });
                    }
                    this.tableData = arr;
                    this.totalCount = result.data.count;
                    this.currentPage = this.page;
                } else {
                    this.$message({
                        message: result.msg,
                        type: "warning"
                    });
                }
            },
            refreshTable() {
                this.page = 1;
                this.tableList();
            },
            handleClick(type, item) {
                if (type == "reset_password") {
                    this.resetPassword(item.student_id, item.realname);
                } else if (type == "setting") {
                    this.$router.push({
                        path: 'studentIndex/studentInfo',
                        query: {
                            student_id: item.student_id
                        }
                    });
                }
            },
            handleSizeChange(value) {
                this.limit = value;
                this.tableList();
            },
            handleCurrentChange(value) {
                this.page = value;
                this.tableList();
            },
            // 重置密码
            resetPassword(id, name) {
                let data = {
                    request: ResetPasswordStudent,
                    field: ResetPasswordStudent_field,
                    source: {
                        realname: name,
                        student_id: id
                    },
                    labelWidth: "120px"
                };
                DialogForm({
                    title: "重置密码",
                    data,
                    success: result => {
                        this.$message({
                            message: result.msg,
                            type: "success"
                        });
                    }
                });
            },
            // 新增学员
            async addStudent() {
                // 获取班级
                let params = {
                    token: Lockr.get("teacherToken")
                };
                let classList = [];
                let studentList = [];
                let result = await ClassListSelect(params);
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    classList = getSelectData(result.data.list, "name", "id");
                }
                // 获取学员
                let params1 = {
                    token: Lockr.get("teacherToken"),
                    teacher_class_id: ""
                };
                let result1 = await UnjoinStudent(params1);
                if (result1.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    studentList = getSelectData(result1.data, "realname", "id");
                }
                this.showAddStudent(studentList, classList);
            },
            showAddStudent(studentList, classList) {
                let data = {
                    request: SaveStudent,
                    field: TeacherAddStudent_field,
                    source: {
                        teacher_class_id: this.classId
                    },
                    setting: {
                        teacher_class_id: classList,
                        student_id: studentList
                    },
                    labelWidth: "120px"
                };
                DialogForm({
                    title: "添加学员",
                    data,
                    success: result => {
                        this.refreshTable();
                        this.$message({
                            message: result.msg,
                            type: "success"
                        });
                    }
                });
            },
            // 批量选择
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 删除学员
            delStudentBtn() {
                if (!this.multipleSelection.length) {
                    this.$message({
                        type: "warning",
                        message: "缺少操作数据，请勾选后再操作！"
                    });
                    return null;
                }
                this.$confirm("此操作将删除所选学员, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.$prompt("请输入登录密码", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            inputPlaceholder: "请输入密码",
                            inputType: "password",
                            center: true
                        })
                            .then(({value}) => {
                                this.requestDelStudent(value);
                            })
                            .catch(() => {
                                this.$message({
                                    type: "info",
                                    message: "取消输入"
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除"
                        });
                    });
            },
            async requestDelStudent(password) {
                let ids = this.multipleSelection.map(item => {
                    return item.id;
                });
                let params = {
                    token: Lockr.get("teacherToken"),
                    password: password,
                    id: ids.join(",")
                };
                let result = await BatchDelStudent(params);
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.$message({
                        message: result.msg,
                        type: "success"
                    });
                    this.refreshTable();
                } else {
                    this.$message({
                        message: result.msg,
                        type: "warning"
                    });
                }
            },
            // 注册课程
            async registerCourse() {
                if (!this.multipleSelection.length) {
                    this.$message({
                        type: "warning",
                        message: "缺少操作数据，请勾选后再操作！"
                    });
                    return null;
                }
                let params = {
                    token: Lockr.get("teacherToken")
                }
                let result = await CourseList(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.courseType = getSelectData(
                        result.data,
                        "name",
                        "id"
                    );
                    this.openRegisterCourse()
                } else {
                    this.$message({
                        message: result.msg,
                        type: "warning"
                    });
                }

            },
            openRegisterCourse() {
                let ids = this.multipleSelection.map(item => {
                    return item.id;
                });
                let data = {
                    request: SaveCourse,
                    field: TeacherStudentCourse_field,
                    student_id: ids.join(","),
                    source: {
                        student_id: ids.join(",")
                    },
                    setting: {
                        curriculum_type: this.courseType
                    },
                    linkage: {
                        curriculum_type: {
                            field: 'curriculum_id',
                            api: TextbookList,
                            linkage_field: 'curriculum_edition_id',
                            params: {
                                token: Lockr.get("teacherToken"),
                                student_id: ids.join(",")
                            }
                        }
                    },
                    labelWidth: "120px"
                };
                DialogForm({
                    title: "注册课程",
                    data,
                    success: result => {
                        this.$message({
                            message: result.msg,
                            type: "success"
                        });
                    }
                });
            },
            // 导入学员
            ImportExcelOpen() {
                this.$refs.ImportExcel.open()
            }
        },
        created() {
            this.init();
        },
        beforeCreate() {
            document
                .querySelector("body")
                .setAttribute("style", "background-color:#fff");
        }
    };
</script>

<style scoped lang='less'>
    @import "../../assets/css/form";

    .tab-box {
        background: #fff;
        padding: 16px;

        .el-button--text {
            font-size: 14px;
            font-weight: bold;
        }

        .el-button--text:nth-of-type(1) {
            color: #fb8048;
        }

        .tab-title-btn {
            padding: 15px 20px;
            background: #f7f4f8;
            display: flex;
            justify-content: space-between;
            align-items: center;

            > div:nth-of-type(2) {
                color: #416489;
                cursor: pointer;
            }

            > div:nth-of-type(2):hover {
                color: #2c7d89;
            }
        }

        .el-table {
            font-size: 14px;
            margin-top: 20px;
        }

        .page-block {
            padding-top: 15px;
        }
    }

    .dislog-box {
        padding: 20px 20%;
        background: #fff;

        .dialog-footer {
            text-align: center;
        }

        .select-course {
            border: 1px solid #dcdcdc;
            height: 38px;
            padding-left: 15px;
            transition: all 0.5s;
            border-radius: 3px;
            cursor: pointer;

            img {
                width: 13px;
                height: 13px;
                float: right;
                margin-top: 10px;
                margin-right: 10px;
            }
        }

        .select-course:hover {
            border: 1px solid #409eff;
        }
    }

    .delsuccess-box {
        > div:nth-of-type(1) {
            display: flex;
            justify-content: center;
        }

        .delsuccess-btn {
            display: flex;
            align-items: center;
            flex-direction: column;
            font-size: 24px;

            > div {
                margin-top: 20px;
            }
        }
    }
    /deep/ .el-form-item:nth-child(2){
        width: auto !important;
    }
</style>
